import { render, staticRenderFns } from "./Cargados.vue?vue&type=template&id=3ec0726c"
import script from "./Cargados.vue?vue&type=script&lang=js"
export * from "./Cargados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports